import Axios from "@/plugins/Axios";

export class CensoService {
  async getFilterData30(type) {
    const response = await Axios()
      .get(`/censo/get-data-filter/${type}`)
      .then((response) => {
        return response.data;
      });
    return response;
  }

  async export(type) {
    const response = await Axios()
      .get(`/censo/exportar/${type}`, { responseType: "arraybuffer" })
      .then((response) => {
        const link = document.createElement("a");
        link.download = `planilha_censo_${type}.xlsx`;
        link.href = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/vnd.ms-excel" })
        );
        link.click();
      });
    return response;
  }

  async getData(type) {
    const response = await Axios().get(`/censo/get-data/${type}`);
    const resp = response.data;
    return resp;
  }

  async saveData(data, type) {
    const response = await Axios().post(`/censo/save-data/${type}`, data);
    const resp = response.data;
    return resp;
  }

  async gerarFile() {
    const response = await Axios().get(`/censo/gerarFile`);
    const resp = response.data;
    return resp;
  }

  async getPercent(type) {
    const response = await Axios()
      .get(`/censo/percentualPreenchimento/${type}`)
      .then((response) => {
        return response.data;
      });
    return response;
  }

  async import(file, type) {
    const formData = new FormData();
    formData.append("file", file);
    Axios().interceptors.request.use((config) => {
      config.headers["Content-Type"] = "multipart/form-data";
      return config;
    });
    const response = await Axios().post(`/censo/importar/${type}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  }

  async getPaginatedData30(params) {
    const response = await Axios().get(`/censo/pessoas/paginated`, { params });
    return response.data;
  }

  async getPaginatedData60(params) {
    const response = await Axios().get(`/censo/matriculas/paginated`, { params });
    return response.data;
  }
}
export default new CensoService();
